export const ExportTypeDropdownName = 'ExportType';



// WEBPACK FOOTER //
// ./src/common/Constants/exportTypeDropdownName.js